import { createContext, useContext, useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setTokenState] = useState(() => localStorage.getItem('tp360_token'));
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    checkAuth();
  }, []);
  
  const checkAuth = async () => {
    const storedToken = localStorage.getItem('tp360_token');
    const storedUser = localStorage.getItem('tp360_user');
    
    if (!storedToken || !storedUser) {
      setLoading(false);
      return;
    }
    
    try {
      const response = await fetch(`${API_URL}/api/auth/verify`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${storedToken}`,
          'Content-Type': 'application/json'
        }
      });
      
      if (response.ok) {
        setUser(JSON.parse(storedUser));
        setTokenState(storedToken);
      } else {
        // Token invalid, clear storage
        localStorage.removeItem('tp360_token');
        localStorage.removeItem('tp360_user');
        setTokenState(null);
      }
    } catch (error) {
      console.error('Auth check failed:', error);
      // Keep user logged in if server is unreachable but token exists
      setUser(JSON.parse(storedUser));
      setTokenState(storedToken);
    } finally {
      setLoading(false);
    }
  };
  
  const login = (userData) => {
    setUser(userData);
    setTokenState(localStorage.getItem('tp360_token'));
  };
  
  const logout = () => {
    localStorage.removeItem('tp360_token');
    localStorage.removeItem('tp360_user');
    setUser(null);
    setTokenState(null);
  };
  
  const getToken = () => {
    return localStorage.getItem('tp360_token');
  };
  
  return (
    <AuthContext.Provider value={{ user, token, loading, login, logout, getToken }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
